import { render } from "./how-to-be-more-productive-working-from-home.vue?vue&type=template&id=8a1b094e"
const script = {}
script.render = render

export default script